import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { FEATURE_KEYS } from '~/shared/constants/commonConstants'
import { setIsDirectStripePaymentEnabledAction } from '~/shared/store/payment/actions'

export const useDirectStripePaymentFeature = (): void => {
  const dispatch = useDispatch()
  const isDirectStripePaymentEnabled = useFeatureIsOn(
    FEATURE_KEYS.direct_stripe_payment,
  )

  useEffect(() => {
    dispatch(
      setIsDirectStripePaymentEnabledAction(isDirectStripePaymentEnabled),
    )
  }, [dispatch, isDirectStripePaymentEnabled])
}
